module.exports = __webpack_public_path__ + "img/news6-2.54181b20.png";